// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.about-page {
  background: linear-gradient(to bottom, #11224E 79%, white 70%);
  color: white;
  perspective: 1000px;
}

.content {
  display: flex;
  align-items: center;
  padding-bottom: 2em;
  padding-left: 5em;
  z-index: 2; 
}

.about-section {
  font-size: 1em;
  margin: 0;
  font-weight: 300;
  width: 100%;
  text-align: center;
}

.orange-title {
  font-family: "Rubik", sans-serif;
  font-weight: 800;
  color: #c44e00;
  font-size: 2.5em;
  margin-bottom: 0vh;
}
.orange-title-cv {
  font-family: "Rubik", sans-serif;
  font-weight: 800;
  color: #c44e00;
  font-size: 2.5em;
  margin-bottom: -8vh;
  z-index: 10;
}

.about-section p {
  text-align: justify;
  font-weight: lighter;
  position: relative;
  font-size: 0.9em;
}

.image-section {
  width: 100%;
  max-height: 700px;
  min-height: 800px;
  overflow: hidden;
  position: relative;
  z-index: 1; 
}

.image-section img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.research-component {
  width: 100%;
  position: relative;
  margin-top: -70px; 
  z-index: 3;
}



@media (min-width: 600px) {
  
  .content {
    flex-direction: row;
    justify-content: space-around;
  }

  .about-section {
    width: 50%;
    text-align: left;
    padding-left: 2em;
    font-size: 1em;
  }

  .image-section {
    width: 50%;
    height: 150vh;
    overflow: hidden;
    position: relative;
  }

  .image-section img {
    width: auto;
    height: 100%;
    left: 10%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
  }

  .research-component {
    position: relative;
    z-index: 3; 
    top: -40px; 
    background: transparent;
  }
}


@media (min-width: 1600px) {
  .about-page {
    height: 120vh;
    background: linear-gradient(to bottom, #11224E 80%, white 20%);
    color: white;
    perspective: 1000px;
  }

  .content {
    flex-direction: row;
    justify-content: space-around;
  }

  .about-section {
    width: 50%;
    text-align: left;
    padding-left: 2em;
    font-size: 1.5em;
  }

  .image-section {
    width: 50%;
    height: 150vh;
    overflow: hidden;
    position: relative;
  }

  .about-section p {
    text-align: justify;
    font-weight: lighter;
    position: relative;
    font-size: 0.6em;
  }

  .image-section img {
    height: 90%;
  }

  .research-component {
    position: relative;
    margin-top: -120px; 
    z-index: 3;
  }
}



@media (max-width: 768px) {
  .about-page {
    height: auto; 
    background: linear-gradient(to bottom, #11224E 90%, white 15%);
    color: white;
    perspective: 1000px;
  }

  .content {
    flex-direction: column-reverse;
    align-items: center;
    padding: 0em 1em;
  }

  .about-section {
    width: 90%;
    text-align: justify;
  }
  .about-section p {
    width: 100%;
    text-align:justify;
    padding-left: 0;
    font-size: larger;
  }

  .image-section {
    width: 100%;
    min-height: 45vh;
    overflow: hidden;
    position: relative;
  }

  .image-section::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 70%;
    filter: blur(1000px);
    z-index: 1;
  }

  .image-section img {
    display: flex;
    margin: 0 auto;
    width: 100%;
    height: auto;
    transform: translate(-50%, -45%) scale(0.8);
    z-index: 2;
    margin-top: 1vh;
  }

  .orange-title {
    display: flex;
    justify-content: center;
    font-family: "Rubik", sans-serif;
    font-weight: 800;
    color: #c44e00;
    font-size: 2.5em;
    margin-top: 2vh;

  }

  .research-component {
    position: relative;
    z-index: 3;
    top: 0;
    margin-top: 4px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutPage.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;;;AAIA;;EAEE;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,uBAAuB;EACzB;AACF;;;AAGA;EACE;IACE,aAAa;IACb,8DAA8D;IAC9D,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;AACF;;;;AAIA;EACE;IACE,YAAY;IACZ,8DAA8D;IAC9D,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;;EAEjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,eAAe;EACjB;;AAEF","sourcesContent":[".body {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.about-page {\r\n  background: linear-gradient(to bottom, #11224E 79%, white 70%);\r\n  color: white;\r\n  perspective: 1000px;\r\n}\r\n\r\n.content {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-bottom: 2em;\r\n  padding-left: 5em;\r\n  z-index: 2; \r\n}\r\n\r\n.about-section {\r\n  font-size: 1em;\r\n  margin: 0;\r\n  font-weight: 300;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.orange-title {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 800;\r\n  color: #c44e00;\r\n  font-size: 2.5em;\r\n  margin-bottom: 0vh;\r\n}\r\n.orange-title-cv {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 800;\r\n  color: #c44e00;\r\n  font-size: 2.5em;\r\n  margin-bottom: -8vh;\r\n  z-index: 10;\r\n}\r\n\r\n.about-section p {\r\n  text-align: justify;\r\n  font-weight: lighter;\r\n  position: relative;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.image-section {\r\n  width: 100%;\r\n  max-height: 700px;\r\n  min-height: 800px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 1; \r\n}\r\n\r\n.image-section img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.research-component {\r\n  width: 100%;\r\n  position: relative;\r\n  margin-top: -70px; \r\n  z-index: 3;\r\n}\r\n\r\n\r\n\r\n@media (min-width: 600px) {\r\n  \r\n  .content {\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n  }\r\n\r\n  .about-section {\r\n    width: 50%;\r\n    text-align: left;\r\n    padding-left: 2em;\r\n    font-size: 1em;\r\n  }\r\n\r\n  .image-section {\r\n    width: 50%;\r\n    height: 150vh;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n\r\n  .image-section img {\r\n    width: auto;\r\n    height: 100%;\r\n    left: 10%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n\r\n  .research-component {\r\n    position: relative;\r\n    z-index: 3; \r\n    top: -40px; \r\n    background: transparent;\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 1600px) {\r\n  .about-page {\r\n    height: 120vh;\r\n    background: linear-gradient(to bottom, #11224E 80%, white 20%);\r\n    color: white;\r\n    perspective: 1000px;\r\n  }\r\n\r\n  .content {\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n  }\r\n\r\n  .about-section {\r\n    width: 50%;\r\n    text-align: left;\r\n    padding-left: 2em;\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .image-section {\r\n    width: 50%;\r\n    height: 150vh;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n\r\n  .about-section p {\r\n    text-align: justify;\r\n    font-weight: lighter;\r\n    position: relative;\r\n    font-size: 0.6em;\r\n  }\r\n\r\n  .image-section img {\r\n    height: 90%;\r\n  }\r\n\r\n  .research-component {\r\n    position: relative;\r\n    margin-top: -120px; \r\n    z-index: 3;\r\n  }\r\n}\r\n\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .about-page {\r\n    height: auto; \r\n    background: linear-gradient(to bottom, #11224E 90%, white 15%);\r\n    color: white;\r\n    perspective: 1000px;\r\n  }\r\n\r\n  .content {\r\n    flex-direction: column-reverse;\r\n    align-items: center;\r\n    padding: 0em 1em;\r\n  }\r\n\r\n  .about-section {\r\n    width: 90%;\r\n    text-align: justify;\r\n  }\r\n  .about-section p {\r\n    width: 100%;\r\n    text-align:justify;\r\n    padding-left: 0;\r\n    font-size: larger;\r\n  }\r\n\r\n  .image-section {\r\n    width: 100%;\r\n    min-height: 45vh;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n\r\n  .image-section::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: 70%;\r\n    filter: blur(1000px);\r\n    z-index: 1;\r\n  }\r\n\r\n  .image-section img {\r\n    display: flex;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    transform: translate(-50%, -45%) scale(0.8);\r\n    z-index: 2;\r\n    margin-top: 1vh;\r\n  }\r\n\r\n  .orange-title {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-family: \"Rubik\", sans-serif;\r\n    font-weight: 800;\r\n    color: #c44e00;\r\n    font-size: 2.5em;\r\n    margin-top: 2vh;\r\n\r\n  }\r\n\r\n  .research-component {\r\n    position: relative;\r\n    z-index: 3;\r\n    top: 0;\r\n    margin-top: 4px;\r\n  }\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
